import { useState } from "react";

export default function Accordion({ items = [], allowMultiple = true, startClosed = false }) {
  const [open, setOpen] = useState(() =>
    !startClosed && items[0] ? { [items[0].id]: true } : {}
  );

  function toggle(id) {
    setOpen((current) => {
      if (allowMultiple) {
        return { ...current, [id]: !current[id] };
      }
      return { [id]: !current[id] };
    });
  }

  return (
    <div className="accordion">
      {items.map((item) => {
        const isOpen = Boolean(open[item.id]);
        return (
          <section key={item.id} className={`accordion-item${isOpen ? " is-open" : ""}`}>
            <button
              type="button"
              className="accordion-trigger"
              aria-expanded={isOpen}
              data-tour={item.id === items[0]?.id ? "seller-tip-0" : undefined}
              onClick={() => toggle(item.id)}
            >
              <span>{item.title}</span>
              <span className="accordion-icon" aria-hidden="true">
                {isOpen ? "−" : "+"}
              </span>
            </button>
            {isOpen ? <div className="accordion-panel">{item.content}</div> : null}
          </section>
        );
      })}
    </div>
  );
}
